module.exports = __webpack_public_path__ + "img/arrow-top.984d521f.svg";